export default "__VITE_ASSET__670fc9ef__"